/* Made by Minga — Site Refresh interactions. Safe to run multiple times (theme editor). */
(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(root){
    if(root.dataset.mrReady) return; root.dataset.mrReady = 1;
    var slides = [].slice.call(root.querySelectorAll('.mr-hero__slide'));
    if(slides.length < 2) return;
    var n = root.querySelector('[data-mr-count]'), cap = root.querySelector('[data-mr-cap]');
    var i = 0, t, speed = (parseInt(root.dataset.speed,10)||5)*1000;
    function go(k){
      i = (k + slides.length) % slides.length;
      slides.forEach(function(s,j){ s.classList.toggle('is-on', j===i); });
      if(n) n.textContent = (i+1) + ' / ' + slides.length;
      if(cap) cap.textContent = slides[i].dataset.caption || '';
    }
    var paused = false;
    function auto(){ clearInterval(t); if(paused || reduce || root.dataset.autoplay === 'false') return; t = setInterval(function(){ go(i+1); }, speed); }
    var p = root.querySelector('[data-mr-prev]'), x = root.querySelector('[data-mr-next]'), pb = root.querySelector('[data-mr-pause]');
    p && p.addEventListener('click', function(){ go(i-1); auto(); });
    x && x.addEventListener('click', function(){ go(i+1); auto(); });
    function setPaused(v){
      paused = v;
      if(pb){
        pb.classList.toggle('is-paused', paused);
        pb.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pb.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        var lbl = pb.querySelector('[data-mr-pause-text]');
        if(lbl) lbl.textContent = paused ? 'Play slideshow' : 'Pause slideshow';
      }
      auto();
    }
    if(pb){ pb.addEventListener('click', function(){ setPaused(!paused); }); if(reduce) setPaused(true); }
    auto();
  }

  function initWords(root){
    if(root.dataset.mrReady) return; root.dataset.mrReady = 1;
    var list = root.querySelector('.mr-words__list'); if(!list) return;
    var items = [].slice.call(list.querySelectorAll('.mr-words__item'));
    var fine = matchMedia('(hover: hover) and (min-width: 761px)');
    items.forEach(function(w){
      w.addEventListener('mouseenter', function(){ if(!fine.matches) return; items.forEach(function(x){ x.classList.toggle('is-on', x===w); }); list.classList.add('is-active'); });
      w.addEventListener('mouseleave', function(){ if(!fine.matches) return; w.classList.remove('is-on'); list.classList.remove('is-active'); });
      var im = w.querySelector('img'); if(im && im.decode){ im.decode().catch(function(){}); }
    });
    var raf = 0, cur = null;
    function mid(){
      if(fine.matches){ items.forEach(function(x){ x.classList.remove('is-on'); }); cur = null; return; }
      var c = innerHeight/2, best = null, bd = 1e9, cd = 1e9, r = list.getBoundingClientRect();
      items.forEach(function(w){ var b = w.querySelector('a').getBoundingClientRect(); var d = Math.abs(b.top + b.height/2 - c); if(d < bd){ bd = d; best = w; } if(w === cur) cd = d; });
      var inView = r.top - 40 < c && r.bottom + 40 > c;
      if(!inView){ best = null; }
      else if(cur && cd - bd < 28){ best = cur; }
      if(best === cur && best){ return; }
      cur = best;
      items.forEach(function(w,k){
        var on = w === best; w.classList.toggle('is-on', on);
        if(on){ var a = w.querySelector('a').getBoundingClientRect(); var im = w.querySelector('img'); im && im.style.setProperty('--y', (a.top - r.top + a.height/2 + (k%2 ? 18 : -18)) + 'px'); }
      });
    }
    function tick(){ if(!raf) raf = requestAnimationFrame(function(){ raf = 0; mid(); }); }
    addEventListener('scroll', tick, {passive:true}); addEventListener('resize', tick); mid();
  }

  function initSwitch(root){
    if(root.dataset.mrReady) return; root.dataset.mrReady = 1;
    var b = [].slice.call(root.querySelectorAll('[data-mr-i]')),
        im = [].slice.call(root.querySelectorAll('.mr-switch__img img')),
        tx = [].slice.call(root.querySelectorAll('.mr-switch__text p'));
    b.forEach(function(x){
      function g(){ var i = +x.dataset.mrI; b.forEach(function(y){ y.classList.toggle('is-on', y===x); }); im.forEach(function(m,k){ m.classList.toggle('is-on', k===i); }); tx.forEach(function(p,k){ p.classList.toggle('is-on', k===i); }); }
      x.addEventListener('mouseenter', g); x.addEventListener('click', g);
    });
  }

  function initStrip(root){
    if(root.dataset.mrReady) return; root.dataset.mrReady = 1;
    var s = root.querySelector('[data-mr-strip]'); if(!s) return;
    var p = root.querySelector('[data-mr-sprev]'), n = root.querySelector('[data-mr-snext]');
    p && p.addEventListener('click', function(){ s.scrollBy({left:-s.clientWidth*.8, behavior:'smooth'}); });
    n && n.addEventListener('click', function(){ s.scrollBy({left: s.clientWidth*.8, behavior:'smooth'}); });
  }

  function initFilters(root){
    if(root.dataset.mrReady) return; root.dataset.mrReady = 1;
    var t = root.querySelector('[data-mr-ftoggle]'), f = root.querySelector('.mr-filters'), form = root.querySelector('form.mr-filterform');
    t && f && t.addEventListener('click', function(){ f.hidden = !f.hidden; t.textContent = f.hidden ? t.dataset.closed : t.dataset.open; t.setAttribute('aria-expanded', String(!f.hidden)); });
    form && form.addEventListener('change', function(){ form.submit(); });
    var sort = root.querySelector('[data-mr-sort]');
    sort && sort.addEventListener('change', function(){ var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });
  }

  function initFaq(root){
    if(root.dataset.mrReady) return; root.dataset.mrReady = 1;
    var rte = root.querySelector('.mr-rte'); if(!rte) return;
    var nodes = [].slice.call(rte.children), acc = null;
    nodes.forEach(function(el){
      if(/^H[1-6]$/.test(el.tagName)){ el.classList.add('mr-faq-h'); acc = null; if(/still have questions/i.test(el.textContent)){ el.remove(); el._gone = true; } return; }
      if(el.tagName === 'HR'){ el.remove(); return; }
      var first = el.firstElementChild;
      if(el.tagName === 'P' && first && first.tagName === 'STRONG' && el.firstChild === first){
        if(!acc){ acc = document.createElement('div'); acc.className = 'mr-acc'; el.parentNode.insertBefore(acc, el); }
        var d = document.createElement('details'), s = document.createElement('summary'), body = document.createElement('div');
        s.textContent = first.textContent.trim(); s.appendChild(document.createElement('i'));
        first.remove(); var br = el.querySelector('br'); if(br && el.firstChild === br) br.remove();
        body.className = 'mr-acc__body'; var p = document.createElement('p'); p.innerHTML = el.innerHTML.trim(); body.appendChild(p);
        d.appendChild(s); d.appendChild(body); acc.appendChild(d); el.remove();
      } else { acc = null; }
    });
    [].slice.call(rte.querySelectorAll('p')).forEach(function(p){ if(/^send us a note/i.test(p.textContent.trim()) && root.querySelector('.mr-doc__help')) p.remove(); });
  }

  /* square/landscape photos: show whole photo inside tall frames */
  var FIT_SEL = '.product-media-collage__item img, .mp-prod__ph img, .mp-strip__ph img';
  function fitOne(img){
    if(img.dataset.mrFit) return;
    function check(){
      var w = img.naturalWidth || parseInt(img.getAttribute('width'),10), h = img.naturalHeight || parseInt(img.getAttribute('height'),10);
      if(!w || !h) return;
      img.dataset.mrFit = 1;
      var col = img.closest('.product-media-collage__item');
      if(col){ col.style.setProperty('--mr-ar', (w / h).toFixed(4)); col.classList.add('mr-nat'); return; }
      if(w / h >= 0.9){ var fr = img.closest('.mp-prod__ph, .mp-strip__ph'); if(fr) fr.classList.add('mr-sq'); }
    }
    if(img.getAttribute('width') && img.getAttribute('height')) check();
    else if(img.complete) check(); else img.addEventListener('load', check, {once:true});
  }
  function fitAll(scope){ if(!document.body.classList.contains('mr')) return; (scope||document).querySelectorAll(FIT_SEL).forEach(fitOne); }

  function run(scope){
    scope = scope || document;
    scope.querySelectorAll('[data-mr-hero]').forEach(initHero);
    scope.querySelectorAll('[data-mr-words]').forEach(initWords);
    scope.querySelectorAll('[data-mr-switch]').forEach(initSwitch);
    scope.querySelectorAll('[data-mr-strips]').forEach(initStrip);
    scope.querySelectorAll('[data-mr-collection]').forEach(initFilters);
    scope.querySelectorAll('[data-mr-faq]').forEach(initFaq);
    fitAll(scope);
  }
  if(document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function(){ run(); });
  document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  addEventListener('load', function(){ fitAll(document); });
  if(window.MutationObserver){ var pend = 0; var mo = new MutationObserver(function(){ if(pend) return; pend = requestAnimationFrame(function(){ pend = 0; fitAll(document); }); }); document.addEventListener('DOMContentLoaded', function(){ mo.observe(document.body, {childList:true, subtree:true}); }); }
})();
